import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import cls from './PkdLinks.module.less'
import clsx from 'clsx';

export const PkdLinks = () => {

  const { t } = useTranslation();
  const location = useLocation();

  const links = [
    { path: '/pkd/', name: t(`pkd.downloads`), className: cls.pkd },
    { path: '/pkd/indicators/', name: t('pkd.indicators_link'), className: cls.pkdIndicators },
    { path: '/pkd/checklists/', name: t(`pkd.checklists_link`), className: cls.pkdChecklists },
  ]
  console.log('location.pathname',location.pathname);
  return (
    <div className={cls.PkdLinks}>
      {links.map((link) => (
        <Link className={clsx(link.className, { [cls.active]: location.pathname === link.path })} key={link.path} to={link.path}>{link.name}</Link>
      ))}
    </div>
  )
}
